import type { TFunction } from "i18next";

import { getTimeAgo, type TimeTranslations } from "../../../utils/getDate";

export const watchTimeTranslations = (t: TFunction): TimeTranslations => ({
  noData: t("monitoreoIa.units.noUpdate"),
  rightNow: t("time.rightNow"),
  min: t("time.min"),
  hour: t("time.hour"),
  hours: t("time.hours"),
  day: t("time.day"),
  days: t("time.days"),
  month: t("time.month"),
  months: t("time.months"),
  and: t("time.and"),
});

export function formatUpdatedAgo(updatedAt: string | null, t: TFunction): string {
  const translations = watchTimeTranslations(t);
  const seconds = updatedAt ? Math.floor(new Date(updatedAt).getTime() / 1000) : 0;
  const ago = getTimeAgo(Number.isFinite(seconds) ? seconds : 0, translations);

  return ago === translations.rightNow || ago === translations.noData
    ? ago
    : t("monitoreoIa.units.updatedAgo", { time: ago });
}

export function formatAgo(at: string | null, t: TFunction): string {
  const translations = watchTimeTranslations(t);
  const seconds = at ? Math.floor(new Date(at).getTime() / 1000) : 0;
  const ago = getTimeAgo(Number.isFinite(seconds) ? seconds : 0, translations);

  return ago === translations.rightNow || ago === translations.noData
    ? ago
    : t("monitoreoIa.monitoringCenter.ago", { time: ago });
}

export function formatSpeed(speedKph: number | null, t: TFunction): string {
  if (speedKph == null) return t("time.noData");
  return speedKph > 0
    ? t("monitoreoIa.units.speedValue", { speed: speedKph })
    : t("monitoreoIa.units.stopped");
}
